module.exports = __webpack_public_path__ + "static/media/published.2faf4bda.png";